const ROUTES_ROOT = {
  MAIN: '/main',
} as const;

export const ROUTES = {
  MAIN: {
    ROOT: `${ROUTES_ROOT.MAIN}/client-search`,
  },
  MANDATO: {
    ROOT: `${ROUTES_ROOT.MAIN}/ficha-previsional`,
    HOME: `${ROUTES_ROOT.MAIN}/ficha-previsional/home`,
    NUEVO: `${ROUTES_ROOT.MAIN}/ficha-previsional/nuevo`,
    REVOCAR: `${ROUTES_ROOT.MAIN}/ficha-previsional/revocar`,
    DASHBOARD: `${ROUTES_ROOT.MAIN}/ficha-previsional/dashboard`,
    COMPROBANTE: `${ROUTES_ROOT.MAIN}/ficha-previsional/comprobante`,
  } as const,
} as const;
